import React from "react";

import "./styles.less";
import { useTranslation } from "react-i18next";

export const SecurityCompliance = () => {
  const { t } = useTranslation();
  return (
    <section>
      <div className="security-compliance">
        <div className="inner">
          <div className="top">
            <div className="title">{t("security.合规性")}</div>
            <div className="subtitle">{t("security.8")}</div>
          </div>
          <div className="items-warp">
            <div className="item">
              <div className="icon">
                <img
                  src={"//files.authing.co/authing-website/logo-iso.png"}
                  alt="authing logo iso"
                />
              </div>
              <div className="content-warp">
                <div className="title">{t("security.ISO质量体系认证")}</div>
                <div className="content">{t("security.13")}</div>
              </div>
            </div>

            <div className="item">
              <div className="icon">
                <img
                  src={"//files.authing.co/authing-website/logo-gdpr.png"}
                  alt="authing logo gdpr"
                />
              </div>
              <div className="content-warp">
                <div className="title">
                  {t("security.GDPR通用数据保护条例")}
                </div>
                <div className="content">{t("security.12")}</div>
              </div>
            </div>
          </div>
          <div className="items-warp">
            <div className="item">
              <div className="icon">
                <img
                  src={"//files.authing.co/authing-website/logo-soc.png"}
                  alt="authing logo soc"
                />
              </div>
              <div className="content-warp">
                <div className="title">{t("security.10")}</div>
                <div className="content">{t("security.11")}</div>
              </div>
            </div>

            <div className="item">
              <div className="icon">
                <img
                  src={"//files.authing.co/authing-website/logo-djcp.png"}
                  alt="authing logo djcp"
                />
              </div>
              <div className="content-warp">
                <div className="title">{t("security.三级等级保护")}</div>
                <div className="content">{t("security.14")}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
